import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { AuthService } from '../auth.service';
import { AppCommonService } from '../appcommon.service';
import { BlogService } from '../blogs/blog.service';
import { IBlog, BlogDetails, IOffer, OfferDetails } from '../blogs/blog';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
declare var $: any;
@Component({
  templateUrl: "./offerdetail.component.html"
})
export class OfferDetailComponent implements OnInit, AfterViewInit, OnDestroy {
  public pageTitle: string = 'Offer Detail';
  p: number = 1;
  offersList: IOffer[];
  ioffer: IOffer[];
  offer: OfferDetails = new OfferDetails();
  slug: string;
  category: string;
  safeHtml: any;
  private sub: any;
  constructor(private authService: AuthService,
    public blogService: BlogService,
    private route: ActivatedRoute,
    private appCommonService: AppCommonService,
    private sanitizer: DomSanitizer
  ) {
    this.appCommonService.pageContentAdditionalClass = "home-page main-page";
    this.appCommonService.pageName = this.pageTitle;
  }
  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.slug = params['slug'];
      this.category = params['category'];
      this.loadOffersList(this.category);
      window.scrollTo(0, 0);
    });
  }

  ngAfterViewInit() {

  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  loadOffersList(cat) {    
    this.blogService.getOffersList(cat)
      .subscribe(
      (offers: IOffer[]) => {
        this.ioffer = offers.filter(b => b.slug == this.slug);
        this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.ioffer[0].content.rendered);
        offers = offers.filter(b => b.slug != this.slug);
        if (cat) {
          this.offersList = offers.filter(f => f.offer_category.find(c => c.toString() === cat));
        }
        else {
          this.offersList = offers;
        }
      },
      (error: any) => {
        this.blogService.showError("Offer retrieval problem", <any>error)
      }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/genericpages/offerdetail.component.ts